import React, { FC, useEffect, useState } from 'react';
import { ColorResult, PhotoshopPicker } from "react-color";
import Icons from '../../Icons';

interface Props {
  color?: string;
  icon?: string;
  btnLabel: string;
  displayPicker?: boolean;
  onColorChange?: (color: ColorResult) => void;
  onAcceptColor?: (colorHex: string) => void;
  onClosePicker?: () => void;
}

const BtnEditorPicker: FC<Props> = ({ btnLabel, color, icon, displayPicker, onAcceptColor, onClosePicker, onColorChange }) => {
  const [showPicker, setShowPicker] = useState<boolean>(displayPicker ?? false);
  const [savedColor, setSavedColor] = useState<string>(color ?? '#000000');

  useEffect(() => {
    if (color && color.length > 0 && color !== savedColor) {
      setSavedColor(color);
    }
  }, [color]);

  useEffect(() => {
    if (displayPicker !== undefined && displayPicker !== showPicker) {
      setShowPicker(displayPicker);
    }
  }, [displayPicker]);

  return (
    <>
      <button className="batAutoBtnEditor  mb-2" onClick={() => setShowPicker(true)}>
        <span className="d-flex align-items-center">
          {icon && <Icons icon={icon} size="30" color="black" />}
          <span className="my-2 pl-2">{btnLabel}</span>
        </span>
      </button>
      {showPicker &&
        <div className="photoshop-picker-custom">
          <PhotoshopPicker
            color={savedColor}
            onChangeComplete={color => {
              setSavedColor(color.hex);
              onColorChange?.(color);
            }}
            onAccept={() => {
              setShowPicker(false);
              onAcceptColor?.(savedColor);
            }}
            onCancel={() => {
              setShowPicker(false);
              onClosePicker?.();
            }}
          />
        </div>
      }
    </>
  );
};

export default BtnEditorPicker;
